import { chakra } from '@plurall/elo-v3';

import { scrollTabsContentRecipe, scrollTabsListRecipe, scrollTabsRootRecipe } from './scrollTabs.recipe';

export const ScrollTabsRootFactory = chakra('div', scrollTabsRootRecipe);
export const ScrollTabsListFactory = chakra('div', scrollTabsListRecipe);
export const ScrollTabsContentFactory = chakra('div', scrollTabsContentRecipe);
